var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kst-section',{attrs:{"title":_vm.sectionTitle}},[_c('kst-input',{attrs:{"field":"DeliveryAddress","data":_vm.userData,"catalog":_vm.Catalog}}),_c('kst-input',{attrs:{"field":"DeliveryDate","data":_vm.userData,"catalog":_vm.Catalog,"customValidations":_vm.deliveryDateValidations}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }